import React from 'react';
import { Switch } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import Text from '../../../../components/Text';
import styled from 'styled-components';

interface ActivePrintSwitchProps {
  value?: boolean;
  onChange?: (value: boolean) => void;
}

const ActivePrintSwitch = ({ value, onChange }: ActivePrintSwitchProps) => {
  return (
    <Container>
      <Switch
        checked={value}
        onChange={onChange}
        checkedChildren={<CheckOutlined />}
        unCheckedChildren={<CloseOutlined />}
      />

      <Text variant='H9' ml={1}>
        Activate Print Coupon
      </Text>
    </Container>
  );
};

export default ActivePrintSwitch;

const Container = styled.div`
  display: flex;
  align-items: center;
`;
